module.exports = __webpack_public_path__ + "img/tmdb-stacked-green.24a6fdb9.svg";